.list {
	flex: 1;
	list-style: none;
	margin: 0;
	outline: none;
	overflow-y: auto;
	padding: 0;
}

.list li {
	gap: 0;
	margin: 0;
	height: fit-content;
	display: block;
}

.list::-webkit-scrollbar {
	width: 8px;
}

.list::-webkit-scrollbar-track {
	background: transparent;
}

.list::-webkit-scrollbar-thumb {
	background-color: var(--border-primary);
	border-radius: 4px;
}

.list::-webkit-scrollbar-thumb:hover {
	background-color: var(--content-tertiary);
}
